export const fileTypes = {
  FILE_UPLOADED: "FILE_UPLOADED",
  CANCEL_UPLOAD: "CANCEL_UPLOAD",
};
